import { jsx as _jsx } from "react/jsx-runtime";
import { DisplayText } from "../../../../components";
import { ESpacings } from "../../../../components/Grid";
// @ts-ignore
export var Subtitle = function (_a) {
    var title = _a.schema.title;
    return (_jsx("div", { style: { marginTop: ESpacings.tight }, children: _jsx(DisplayText, { size: "small", children: title }) }));
};
